import { defineChain, type Chain } from 'viem'
import { createPublicClient, http } from 'viem'

export const bscTestnet = defineChain({
  id: 97,
  name: 'BSC Testnet',
  nativeCurrency: {
    name: 'tBNB',
    symbol: 'tBNB',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://bsc-testnet-rpc.publicnode.com'],
    },
    public: {
      http: [
        'https://bsc-testnet-rpc.publicnode.com',
        'https://data-seed-prebsc-1-s1.binance.org:8545/',
        'https://data-seed-prebsc-2-s1.binance.org:8545/',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://testnet.bscscan.com',
    },
  },
  testnet: true,
})

export const arcTestnet = defineChain({
  id: 5042002,
  name: 'Arc Testnet',
  nativeCurrency: {
    name: 'USDC',
    symbol: 'USDC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.testnet.arc.network'],
    },
    public: {
      http: [
        'https://rpc.testnet.arc.network',
        'https://rpc.blockdaemon.testnet.arc.network',
        'https://rpc.drpc.testnet.arc.network',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'ArcScan',
      url: 'https://testnet.arcscan.app',
    },
  },
  testnet: true,
})

export const SUPPORTED_CHAINS = [bscTestnet, arcTestnet] as const

const CHAIN_MAP: Record<number, Chain> = {
  [bscTestnet.id]: bscTestnet,
  [arcTestnet.id]: arcTestnet,
}

export function getChain(chainId: number): Chain {
  return CHAIN_MAP[chainId] || bscTestnet
}

// Cached viem public clients per chain
const clientCache = new Map<number, ReturnType<typeof createPublicClient>>()

export function getViemClient(chainId: number) {
  if (!clientCache.has(chainId)) {
    const chain = getChain(chainId)
    clientCache.set(chainId, createPublicClient({ chain, transport: http() }))
  }
  return clientCache.get(chainId)!
}
